export default "__VITE_ASSET__uRlEwg_0__"